import { Pause, Play } from "lucide-react";

/** Small Pause / Play toggle for anything that moves on its own (WCAG 2.2.2).
 *  `what` finishes the label: "Pause announcements", "Play testimonials". */
const PauseButton = ({
  paused,
  onToggle,
  what,
  className = "",
}: {
  paused: boolean;
  onToggle: () => void;
  what: string;
  className?: string;
}) => (
  <button
    type="button"
    onClick={onToggle}
    aria-label={`${paused ? "Play" : "Pause"} ${what}`}
    className={`btn-caps inline-flex h-8 items-center gap-1.5 rounded-sm border border-hxp-sand-dark bg-background/95 px-2.5 text-xs tracking-[0.08em] text-foreground/80 transition-colors hover:border-foreground/40 hover:text-foreground ${className}`}
  >
    {paused ? <Play size={12} fill="currentColor" aria-hidden="true" /> : <Pause size={12} fill="currentColor" aria-hidden="true" />}
    {paused ? "Play" : "Pause"}
  </button>
);

export default PauseButton;
